export interface OrgPermissions {
  users: boolean;         // view /users page (see team members)
  users_manage: boolean;  // invite, remove members, change their roles
  roles_manage: boolean;  // create / edit / delete custom roles
  projects: boolean;      // create new projects
  customers: boolean;     // access Customers section (Companies & Users) and add/edit records
  onboarding: boolean;    // access Onboarding section
  taskboards: boolean;
  whiteboards: boolean;
  documents: boolean;
  meetings: boolean;
  settings: boolean;
  messenger: boolean;     // access team messenger FAB
  product_insights: boolean;
  product_prioritize: boolean;
  product_features: boolean;
  product_initiatives: boolean;
  product_releases: boolean;
  product_objectives: boolean;
}

export const PERMISSION_LABELS: Record<keyof OrgPermissions, string> = {
  users:        'View Team Members',
  users_manage: 'Invite & Manage Members',
  roles_manage: 'Manage Roles',
  projects:     'Add Projects',
  customers:    'Manage Customers',
  onboarding:   'Onboarding',
  taskboards:   'Task Boards',
  whiteboards:  'Whiteboards',
  documents:    'Documents',
  meetings:     'Meeting Plans',
  settings:     'Settings',
  messenger:    'Team Messenger',
  product_insights:    'Product: Insights',
  product_prioritize:  'Product: Prioritize',
  product_features:    'Product: Features',
  product_initiatives: 'Product: Initiatives',
  product_releases:    'Product: Releases',
  product_objectives:  'Product: Objectives',
};

export const ALL_PERMISSIONS: OrgPermissions = {
  users: true, users_manage: true, roles_manage: true, projects: true, customers: true,
  onboarding: true,
  taskboards: true, whiteboards: true, documents: true,
  meetings: true, settings: true, messenger: true,
  product_insights: true, product_prioritize: true, product_features: true,
  product_initiatives: true, product_releases: true, product_objectives: true,
};

export const EMPLOYEE_PERMISSIONS: OrgPermissions = {
  users: false, users_manage: false, roles_manage: false, projects: false, customers: false,
  onboarding: false,
  taskboards: true, whiteboards: true, documents: true,
  meetings: true, settings: true, messenger: false,
  product_insights: false, product_prioritize: false, product_features: false,
  product_initiatives: false, product_releases: false, product_objectives: false,
};

export const DEFAULT_PERMISSIONS: OrgPermissions = {
  users: false, users_manage: false, roles_manage: false, projects: false, customers: false,
  onboarding: false,
  taskboards: true, whiteboards: true, documents: true,
  meetings: true, settings: false, messenger: false,
  product_insights: false, product_prioritize: false, product_features: false,
  product_initiatives: false, product_releases: false, product_objectives: false,
};
